<template>
  <el-container class="biz">
    <el-container>
      <el-header height="5rem" class="biz-header">
      <div style="display: flex">
        <img class="titleImg" src="../assets/img/logo1.png" />
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          background-color="#ffffff"
          ref="menu"
          text-color="#A9A9A9"
          active-text-color="black">
          <el-menu-item class="navItem"  index="Index">首页</el-menu-item>
          <el-menu-item class="navItem" index="VideoList">视频中心</el-menu-item>
          <el-menu-item class="navItem" index="NewsList" >学习资源</el-menu-item>
          <el-menu-item class="navItem" index="TopicList">视频专题</el-menu-item>
          <el-menu-item class="navItem" index="ExamList">考试中心</el-menu-item>
          <el-menu-item class="navItem" index="QuestionList">试题浏览</el-menu-item>
<!--          <el-menu-item class="navItem" index="Point">个人积分</el-menu-item>-->
        </el-menu>
      </div>
      <div style="display: flex;align-items: center;">
        <span style="margin-left: 35px;color: black;font-size: 12px;margin-top: 1px">当前账号：
        </span>
        <el-dropdown  @command="handleCommand">
            <span style="color: black;font-size: 12px" class="el-dropdown-link">
              {{userName}}
            </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="cancellation">退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>

        <span style="margin-left: 35px;color: black;font-size: 12px;margin-top: 1px">当前积分：<span>{{userPoint}}</span></span>
      </div>
      </el-header>
      <el-main id="allInfo" style="display:flex;flex-direction:column;align-items: center; background-color: #f2f2f2">
        <router-view class="biz-view"/>
      </el-main>
    </el-container>

    <el-dialog
      title="登录"
      :visible.sync="dialogVisible"
      width="500px">
      <el-form :model="passWordForm" :rules="passWordFormrules" ref="passWordForm">
        <el-form-item label="账号:" prop="userMobile" label-width="150px">
          <el-input v-model="passWordForm.userMobile" placeholder="请输入账号"></el-input>
        </el-form-item>
        <el-form-item label="密码:" prop="password" label-width="150px">
          <el-input v-model="passWordForm.password" placeholder="请输入密码" show-password></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" class="btn" @click="loginSystem">登录</el-button>
      </span>
    </el-dialog>
  </el-container>
</template>

<style rel='stylesheet/less' lang='less' scoped>
@import "../assets/less/variables.less";
.titleImg{
  width: 9rem;
  height: 3.75rem;
  margin-right: 2rem;
}
.navItem{
  font-size: 1rem;
}
.el-menu {
  border-bottom: 0px;
  font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol";
}
.font-awesome-icon {
  margin-right: 5px;
}
.vertical-middle {
  vertical-align: middle;
}

.biz {
  display: flex;
  height: 100%;
  .biz-header {
    position: relative;
    z-index: 2;
    width:75rem;
    height: 5rem;
    flex-shrink: 0;
    align-self: center;
  }
}

.biz-header {
  display: flex;
  align-items: center;
  color: #ffffff;
  background-color: white;
  font-size: 18px;
  justify-content: space-between;
  .logo {
    margin-left: 111px;
    font-size: 28px;
  }
  .biz-header-right {
    position: absolute;
    right: 40px;
    display: flex;
    align-items: center;
  }
}
.biz-main {
  .el-menu:first-child {
    border-top: solid 0px #1e7cdd;
  }
  .biz-aside {
    border: none;
    background-color: @clr-bg-grey;
  }

  .biz-history {
    display: flex;
    align-items: center;
    height: 50px;
    padding-left: 20px;
    font-size: 18px;
    color: @clr-title;
  }

  .biz-view {
    padding: 20px;
    width: 1200px;
    height: 100%;
  }
}
</style>

<style rel="stylesheet/less" lang="less">
@import "../assets/less/variables.less";

@font-size: 13px;

.currentLocation {
  font-size: @font-size;
}
.biz-main {
  .el-main {
    padding: 0;
  }
}

.biz-header {
  .el-badge__content {
    border: none;
    background-color: #ff0000;
  }
}

.el-menu:first-child {
  border: none;
}
.biz-history {
  .el-breadcrumb {
    font-size: @font-size;
  }
}

.biz-aside {
  .el-menu {
    font-size: @font-size;
    border-right: none;
    &:first-child {
      border-top: solid 1px @clr-main - #222;
    }
  }
  .el-menu-item {
    font-size: @font-size;
    &.is-active {
      color: #48576a;
      &::after {
        content: ' ';
        position: absolute;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: .2;
        background-color: @clr-bg-grey;
        color: #20a0ff;
      }
    }
  }
  /*.el-submenu {*/
  /*&.is-opened {*/
  /*&::after {*/
  /*content: ' ';*/
  /*position: absolute;*/
  /*left: 0;*/
  /*top: 0;*/
  /*width: 100%;*/
  /*height: 100%;*/
  /*opacity: .1;*/
  /*background-color: #000000;*/
  /*}*/
  /*}*/
  /*}*/
  .el-submenu__title {
    font-size: @font-size;
    i {
      color: #48576a;
    }
  }
  .fatherItem{
    font-size:  @font-size;
  }
  .sonItem{
    font-size: @font-size;
  }
}
.breadcrumb:last-child span{
  font-size: @font-size;
  color: #666666 !important;
}
.noticeItemBox{
  overflow-y: auto;
  .noticeItem {
    cursor: pointer;
    border-radius: 4px;
    padding: 10px;
    i{
      font-size: @font-size;
    }
    span{
      margin-left: 10px;
      font-size:  @font-size;
      color: @clr-msg;
    }
    .count{
      margin-left: 20px;
    }
    &:hover{
      background-color: rgba(255,218,249, .8);
    }
  }
}
.noticeDetailItem {
  height: 56px !important;
  cursor: pointer;
  border-radius: 4px;
  padding: 10px;
  display: flex;
  i{
    font-size:  @font-size;
  }
  .right{
    font-size:  @font-size;
    color: @clr-msg;
    margin-left: 10px;
    span{
      margin-left: 10px;
    }
    .noticeStatus1{
      color:@clr-warn;
    }
    .noticeStatus2{
      color: @clr-green;
    }
  }
  &:hover{
    background-color: rgba(255,218,249, .8);
  }
}

.el-breadcrumb__inner{
  font-weight: 400 !important;
}
.icon{
  width: 20px;
  height:20px;
}
</style>

<script type="text/ecmascript-6">
import { mapState, mapGetters ,mapMutations} from 'vuex'
import viewFunction from "../assets/js/viewFunction";
export default {
  name: 'Home',
  provide(){
    return{
      check:this.check,
      changeActiveIndex: this.changeActiveIndex,
      findUserScore: this.findUserScore,
    }
  },
  data () {
    return {
      activeIndex: 'Index',
      isCollapse: false,
      dialogVisible: false,
      userName: '',
      userPoint: '',
      passWordForm: {
      },
      passWordFormrules: {
        userMobile: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' }
        ],
      },
      clock: null,
      routes: null,
      defaultActive: ''
    }
  },
  created () {
    this.routes = this.$router.options.routes[0]
  },
  mounted () {
    // this.$router.push({path: 'Index'})
    if (this.user!=null){
      this.userName = this.user.userName
      this.findUserScore()
    }
  },
  computed: {
    ...mapState({
      user: state => state.user
    }),
    ...mapGetters({
      navigationList: 'navs'
    })
  },
  destroyed () {
  },
  methods: {
    ...mapMutations({
      setUser: 'setUser'
    }),
    check(){

        this.$message.error('请先登录系统')
        this.dialogVisible = true
    },
    changeActiveIndex(activeIndex){
      this.activeIndex = activeIndex
    },
    handleSelect(key, keyPath) {
      let user = this.user
      if (user== null){
        this.activeIndex = 'Index'
        this.$message.error('请先登录系统')
        this.dialogVisible = true
        return
      }else {
        this.$router.push({path: keyPath[0]})
      }

    },
    checkUserId() {

    },
    loginSystem () {
        let url = '/api/user/userLogin'
        let params = this.passWordForm
        let that = this
        this.axios.post(url,params).then(res =>viewFunction.handlerRes(that,res,function () {
          that.setUser(res.data)
          sessionStorage.setItem('apptoken', res.token)
          that.userName = res.data.userName
          that.dialogVisible = false
          that.findUserScore()
          let data =  that.passWordForm
          setInterval(()=>{
              that.loginFunction(data)
          },60*1000*110)
        }))

    },
    findUserScore(){
      let url = '/api/userRank/findUserScore'
      let params = {
        userId: this.user.userId
      }
      let that = this
      this.axios.post(url,params).then(res =>{
        viewFunction.handlerRes(that,res,function () {
            that.userPoint = res.data
        })
      })
    },
    loginFunction(data){
      let url = '/api/user/userLogin'
      let params = data
      let that = this
      this.axios.post(url,params).then(res =>viewFunction.handlerRes(that,res,function () {
        that.setUser(res.data)
        localStorage.setItem("userInfo",JSON.stringify(res.data))
        sessionStorage.setItem('apptoken', res.token)
        that.userName = res.data.userName
        that.dialogVisible = false
      }))
    },
    handleCommand (command) {
      this.setUser(null)
      this.userName = ''
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Home.vue